export const getProjectLogo = (projectCode: string): string => `${process.env.PUBLIC_URL}/ProjectLogos/${projectCode.toUpperCase()}.png`;

export const projectCodeNormalizedToOriginal = (projectCodeNormalized: string): string => {
    const prefix = projectCodeNormalized.slice(0, 4).toUpperCase(); // Extract the first 4 characters and convert to uppercase
    const suffix = projectCodeNormalized.slice(4); // Extract the remaining characters
    const transformedString = `${prefix}-${suffix}`;
    return transformedString;
};
